import baseTheme from '../baseTheme';
var MuiChip = {
    /* your custom class style overrides here */
    root: {
        borderRadius: '5px',
        fontWeight: 'bold',
        padding: 0,
        height: '18px',
        fontSize: baseTheme.typography.pxToRem(12),
        letterSpacing: '0.02em',
        backgroundColor: baseTheme.palette.grey[300],
        '& .MuiChip-avatar': {
            width: '14px',
            height: '14px',
            marginLeft: baseTheme.spacing(0.5),
            marginRight: -2,
            color: 'inherit',
        },
    },
    label: {
        lineHeight: 1,
        paddingLeft: baseTheme.spacing(0.5),
        paddingRight: baseTheme.spacing(0.5),
        textTransform: 'uppercase',
    },
    avatar: {
        color: 'inherit',
    },
};
export default MuiChip;
//# sourceMappingURL=MuiChip.js.map